export default function Contact(){
    return(
        <>
        
<section
  className="page-title"
  style={{
    backgroundImage: "url(/assets/images/bg/02.jpg)",
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>

  <div class="container">
    <div class="row">
      <div class="col-lg-6">
        <h1>
          Contact Us
        </h1>
        <nav aria-label="breadcrumb" class="page-breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <a href="/">
                <i class="bi bi-house-door me-1"></i>Home</a>
            </li>
          
            <li class="breadcrumb-item active" aria-current="page">Contact Us</li>
          </ol>
        </nav>
      </div>
    </div>
  </div>

  <div id="particles-js"></div>
</section>
<div class="page-content">
<section class="pt-5">
  <div class="container">
    <div class="row align-items-center">
      <div class="col-lg-6 col-md-12 order-lg-1">
        <img class="img-fluid topBottom" src="assets/images/appointment-img.png" alt=""/>
      </div>
      <div class="col-lg-6 col-md-12 mt-10 mt-lg-0 pe-lg-10">
        <div class="box-shadow rounded p-5">
          <div class="theme-title">
          <h6>Get in Touch</h6>
          <h2>Olymipian <span>Laboratories</span>
          </h2>
        </div>
          <form id="contact-form" method="post" action="php/contact.php">
          <div class="messages"></div>
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label>Your Name</label>
                <input id="form_name" type="text" name="name" class="form-control" placeholder="Enter Your Name" required="required" data-error="Name is required."/>
                <div class="help-block with-errors"></div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>Email Address</label>
                <input id="form_email" type="email" name="email" class="form-control" placeholder="Enter Email Address" required="required" data-error="Valid email is required."/>
                <div class="help-block with-errors"></div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label>Phone Number</label>
                <input id="form_phone" type="tel" name="phone" class="form-control" placeholder="Enter Phone number" required="required" data-error="Phone is required"/>
                <div class="help-block with-errors"></div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>Select Product-Type</label>
                <select class="form-control form-select" aria-label="Default select example">
                  <option selected>Select Service</option>
                  <option value="1">TABLETS</option>
                  <option value="2">PEPTIDES</option>
                  <option value="3">INJECTABLES</option>
                </select>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label>Message</label>
                <textarea id="form_message" name="message" class="form-control" placeholder="Write Your Message Here..." rows="4" required="required" data-error="Please,leave us a message."></textarea>
                <div class="help-block with-errors"></div>
              </div>
            </div>
            <div class="col-md-12 mt-3">
              <button class="themeht-btn primary-btn">
                Send Message
              </button>
            </div>
          </div>
        </form>

      </div>
        
      </div>
    </div>
  </div>
</section>




</div>

        
        
        </>
    )
}